(ns net.kestec.mhda-pilgrimage.admin.applications.application-detail-document-list
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Button" :default Button]
    ["@mui/material/IconButton" :default IconButton]
    ["@mui/icons-material/Download" :default DownloadIcon]
    ["@mui/icons-material/DeleteForever" :default DeleteForeverIcon]

    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-medium grid-full text-field text-field-multi select radio-yes-no]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.public.applications.applications-events :as-alias applications-events]
    [net.kestec.mhda-pilgrimage.route :as-alias route]
    [net.kestec.mhda-pilgrimage.lib-ui.are-you-sure-popup :as are-you-sure-popup]
    [net.kestec.mhda-pilgrimage.admin.applications.application-events :as admin-application-events]
    [net.kestec.mhda-pilgrimage.lib-ui.form-uploads :as form-uploads]

    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]
    ))


(defn med-documents-part [application groups]

  (into [:ul]
        (for [doc (:med_documents application)]
          [:li
           [:> Button {:startIcon (r/as-element [:> DownloadIcon])
                       :variant   "outlined"
                       :target    "_blank"
                       :href      (str "/api/pilgrimage/" (:pilgrimage application) "/application/" (:id application) "/file/" (:file doc))}
            (:file_name doc)]
           (when (some #(= % "/pilgrimage_admin") groups)
             [:> IconButton {:onClick #(rf/dispatch [::are-you-sure-popup/set-show-are-you-sure-popup (assoc doc :type :med)])}
              [:> DeleteForeverIcon]
              ])

           ]
          )))

(defn nurse-documents-part [application groups]
  (into [:ul]
        (for [doc (:nurse_documents application)]
          [:li
           [:> Button {:startIcon (r/as-element [:> DownloadIcon])
                       :variant   "outlined"
                       :target    "_blank"
                       :href      (str "/api/pilgrimage/" (:pilgrimage application) "/application/" (:id application) "/file/" (:file doc))}
            (:file_name doc)]
           (when (some #(= % "/pilgrimage_admin") groups)
             [:> IconButton {:onClick #(rf/dispatch [::are-you-sure-popup/set-show-are-you-sure-popup (assoc doc :type :nurse)])}
              [:> DeleteForeverIcon]
              ])]
          )))

(defn document-list [application]
  (let [groups @(rf/subscribe [::db/get ::db/me :enriched-session :groups])]
    (when (or
            true
            (some #(= % "/admin_MED") groups)
            (some #(= % "/pilgrimage_admin") groups))
      [:<>
       [are-you-sure-popup/are-you-sure-popup
        (fn [doc] [:span "Bist du sicher, dass du dieses Dokument `" (:file_name doc) "` löschen möchtest?" [:br]])
        (fn [doc]
          (cond
            (= (:type doc) :nurse) (rf/dispatch [::admin-application-events/remove-nurse-document (:file doc)])
            (= (:type doc) :med) (rf/dispatch [::admin-application-events/remove-med-document (:file doc)])))]

       [grid-full [:> Typography {:variant "h3"} "Attest Dokumente: "]]
       [med-documents-part application groups]

       [grid-full
        [:br]
        [form-uploads/file-upload "Attest Dokumente hochladen"
         :multiple true
         :on-change [::admin-application-events/store-med-documents]]]


       [grid-full [:> Typography {:variant "h3"} "Pflege Dokumente: "]]
       [nurse-documents-part application groups]
       [grid-full
        [:br]
        [form-uploads/file-upload "Pflegeanamnese Dokumente hochladen"
         :multiple true
         :on-change [::admin-application-events/store-nurse-documents]]]

       [grid-full]

       ]
      )))


